import {
  BOOKING_CALENDAR_HEADER_ROW_HEIGHT,
  RideStatusEnum,
  RydeUiUnit,
} from "@ryde/shared";
import { blueGreyMui, deepPurpleMui, rydeColors } from "@ryde/theme";

import { RidesCalendarRowsFilter } from "./rides-calendar.models";

export const RIDES_CALENDAR_ENTITY: RydeUiUnit = "ride";

export const RIDES_CALENDAR_HOUR_ROW_COUNT = 24;

export const RIDES_CALENDAR_HEADER_ROW_HEIGHT =
  BOOKING_CALENDAR_HEADER_ROW_HEIGHT;

export const RIDES_CALENDAR_HOUR_COLUMN_WIDTH_PX = 109;

export const RIDES_CALENDAR_DAY_COLUMN_WIDTH_PX = 308;

export const RIDES_CALENDAR_HOUR_ROW_HEIGHT_PX = 140;

export const RIDES_CALENDAR_FOOTER_HEIGHT_PX = 22;

export const RIDES_CALENDAR_CELL_PADDING_PX = 3;

export const RIDES_CALENDAR_HOUR_LABEL_PAD_LENGTH = 2;

export const RIDES_CALENDAR_DATE_PART_PAD_LENGTH = 2;

export const RIDES_CALENDAR_CELL_VISIBLE_CHIP_COUNT = 2;

export const RIDES_CALENDAR_CELL_EXPAND_POPPER_MAX_HEIGHT_PX = 480;

export const RIDES_CALENDAR_CELL_EXPAND_POPPER_WIDTH_PX = 360;

export const RIDES_CALENDAR_OUTER_VIEWPORT_OFFSET_PX = 188;

export const RIDES_CALENDAR_OUTER_MIN_HEIGHT_PX = 400;

export const RIDES_CALENDAR_SCROLLBAR_GUTTER_PX = 18;

export const RIDES_CALENDAR_LAST_ROW_SPACER_PX = 22;

export const RIDES_CALENDAR_MAP_DEFAULT_GRID_PERCENT = 60;

export const RIDES_CALENDAR_MAP_MIN_GRID_PERCENT = 25;

export const RIDES_CALENDAR_MAP_MAX_GRID_PERCENT = 80;

export const RIDES_CALENDAR_MAP_RESIZE_THROTTLE_MS = 300;

export const RIDES_CALENDAR_ROWS_FILTER_VALUES: readonly RidesCalendarRowsFilter[] =
  ["all", "with_rides"] as const;

export const RIDES_CALENDAR_ROWS_FILTER_LABEL_KEYS: Record<
  RidesCalendarRowsFilter,
  string
> = {
  all: "ride.calendar.rowsFilterAll",
  with_rides: "ride.calendar.rowsFilterWithRides",
};

export const RIDES_CALENDAR_ROWS_FILTER_DEFAULT_LABELS: Record<
  RidesCalendarRowsFilter,
  string
> = {
  all: "All hours",
  with_rides: "Only hours with rides",
};

export const RIDES_CALENDAR_ROWS_FILTER_MIN_WIDTH_PX = 200;

export const RIDES_CALENDAR_VIEW_SWITCH_ACTIVE_ICON_COLOR = deepPurpleMui.A700;

export const RIDES_CALENDAR_VIEW_SWITCH_INACTIVE_ICON_COLOR = blueGreyMui.A200;

export const RIDES_CALENDAR_STATUS_FALLBACK_COLOR = rydeColors.darkBlue;

export const RIDES_CALENDAR_STATUS_COLOR: Partial<
  Record<RideStatusEnum, string>
> = {
  [RideStatusEnum.Draft]: rydeColors.softGray,
  [RideStatusEnum.New]: rydeColors.lightBlue,
  [RideStatusEnum.Approved]: rydeColors.greenishTeal,
  [RideStatusEnum.Rejected]: rydeColors.crisisRed,
  [RideStatusEnum.Sent]: rydeColors.steel,
  [RideStatusEnum.Received]: rydeColors.venetianNights,
  [RideStatusEnum.OnRoute]: rydeColors.princetonOrange,
  [RideStatusEnum.Done]: rydeColors.thujaGreen,
  [RideStatusEnum.DoneApproved]: rydeColors.lightThujaGreen,
  [RideStatusEnum.Canceled]: rydeColors.grey,
  [RideStatusEnum.Sending]: rydeColors.darkSteel,
  [RideStatusEnum.Declined]: rydeColors.goryRed,
};
